<h2 id="template_add_title" mat-dialog-title>@if (!isCopy) {
  <span>Add</span>
  }@if (isCopy) {
  <span>Copy</span>
} Role</h2>
<mat-dialog-content>
  <form id="addRole" class="template-form" (ngSubmit)="saveClick()">

    <mat-form-field class="user-full-width">
      <input id="role_add_name" matInput placeholder="New Role Name" type="text" [disabled]="displayCompanySelect"
        required name="name" [(ngModel)]="name">
    </mat-form-field>

    @if (displayCompanySelect) {
      <p>Migrate new Role to your other Companies</p>
      <mat-form-field>
        <mat-select placeholder="Select Companies" [formControl]="selectedCompanies" multiple>
          <mat-option disabled="disabled" class="filter-option">
            <button mat-raised-button class="mat-primary fill text-sm" (click)="selectAll()">
              Select All
            </button>
            <button mat-raised-button class="mat-accent fill text-sm" style="margin-left: 10px;" (click)="companyChange([])">
              Deselect All
            </button>
          </mat-option>
          <mat-select-trigger>
            @if (selectedCompanies.value?.[0] == null) {
              None Selected
            }
            @if (selectedCompanies.value?.[0] != null) {
              {{selectedCompanies.value?.[0].name || ''}}
              @if ((selectedCompanies.value?.length || 0) > 1) {
                <span class="example-additional-selection">
                  (+{{(selectedCompanies.value?.length || 0) - 1}} {{selectedCompanies.value?.length === 2 ? 'other' :
                  'others'}})
                </span>
              }
            }
          </mat-select-trigger>
          @for (company of companies; track company) {
            <mat-option [value]="company">{{company.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (!displayCompanySelect) {
    <button mat-button mat-dialog-close [disabled]="saveClicked">
      Cancel
    </button>
  }
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  @if (!displayCompanySelect) {
    <button id="template_add_save" mat-button type="submit" form="addTemplate" [disabled]="saveClicked"
      (click)="saveClick()">
      @if (saveClicked) {
        <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
      }
      @if (!saveClicked) {
        <span>Save</span>
      }
    </button>
  }

  @if (displayCompanySelect) {
    <button mat-button [disabled]="migrateClicked" (click)="close()">
      No
    </button>
  }
  @if (displayCompanySelect) {
    <button mat-button [disabled]="migrateClicked" (click)="migrateClick()">
      @if (migrateClicked) {
        <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
      }
      @if (!migrateClicked) {
        <span>Yes</span>
      }
    </button>
  }
</mat-dialog-actions>
